<template>
  <div class="card shadow-sm border border-light" style="margin-bottom:40px !important;">
    <div class="card-body" style="padding: 16px;">
      <div class="d-flex justify-content-between align-items-center mb-0">
        <titles style="margin: 0;" text="Qərar" />
        <div class="d-flex align-items-center">
          <div v-if="caseItem.decision?.createdBy || caseItem.decision?.updatedBy"
            class="record-label-wrapper position-relative" style="margin-right:12px">
            <el-button type="default" size="large" text style="padding: 0px;" :icon="InfoFilled" class="fs-5" />
            <div class="record-label-tooltip">
              <record-label :created="caseItem.decision.createdBy" :updated="caseItem.decision.updatedBy"
                style="color: #606266; font-size: 14px;" />
            </div>
          </div>
          <el-button class="fs-5" type="text" style="padding: 0px;" :icon="Edit" title="Düzəliş et"
            @click="openDecisionDialog(caseItem.id)">
          </el-button>
        </div>
      </div>
      <hr style="margin-top: 0px;" />
      <div class="col-6" style="color: #606266; font-size: 14px;">
        <div class="row mb-2">
          <div class="col-4 font-weight-bold">Qərar №</div>
          <div class="col-8">{{ caseItem.decision[0].decisionNumber || "-" }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-4 font-weight-bold">Nəticə</div>
          <div class="col-8">{{ caseItem.decision[0].decisionResultText || "-" }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-4 font-weight-bold">Tarix</div>
          <div class="col-8">{{ formatDate(caseItem.decision[0].decisionDate) }}</div>
        </div>
        <div class="row mb-2">
          <div class="col-4 font-weight-bold">Məbləğ (AZN)</div>
          <div class="col-8">{{ formatAmount(caseItem.decision[0].decisionAmount) || "-" }}</div>
        </div>
      </div>
      <hr style="margin-top: 0px;" />
      <div v-if="caseItem.enforcement" class="mt-3 text-end text-success">
        <span><i class="fa fa-check-circle"></i>
          İcraya göndərilib {{ formatDate(caseItem.enforcement.createDate) }}
        </span>
      </div>
      <div v-else class="d-flex justify-content-end mt-3">
        <soft-button type="button" class="btn btn-gradient-warning" :disabled="!canSendToExecution"
          @click="respDialogVisible = true">
          İcraya göndər
        </soft-button>
      </div>
    </div>

    <el-dialog v-model="respDialogVisible" title="Məsul şəxs təyinatı" width="30%" top="200px">
      <el-select v-model="selectedUserId" placeholder="Seçin" size="large" style="width: 100%;">
        <el-option v-for="u in respUsers" :key="u.id" :label="u.name" :value="u.id" />
      </el-select>

      <div class="d-flex justify-content-end mt-4">
        <soft-button type="button" @click="sendToExecution">
          Yadda saxla
        </soft-button>
        &nbsp;&nbsp;
        <soft-button type="button" color="secondary" @click="respDialogVisible = false">
          İmtina
        </soft-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Titles from "@/project/Components/Titles.vue";
import RecordLabel from "@/project/Components/RecordLabel.vue";
import { respUsers, DateTimeToString } from "@/project/Source/helper";
import SoftButton from "@/components/SoftButton.vue";
import { CreateCourtEnforcement } from "@/project/Source/courtenforcements";
import { LastCourtCaseStatus } from "@/project/Source/courts";
import { InfoFilled, Edit } from "@element-plus/icons-vue";

export default {
  components: {
    Titles,
    RecordLabel,
    SoftButton,
  },
  props: {
    caseItem: {
      type: Object,
      required: true,
    },
    openDecisionDialog: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      InfoFilled,
      Edit,
      respDialogVisible: false,
      selectedUserId: null,
      respUsers,
      user: this.$store.state.user.id,
      lastCaseStatus: null,
      lastCaseStatusDate: null,
    };
  },
  computed: {
    canSendToExecution() {
      const d = this.caseItem.decision[0] || {};
      return (
        d.decisionNumber &&
        d.decisionResult !== null &&
        d.decisionDate &&
        d.decisionAmount > 0
      );
    },
  },
  mounted() {
    this.getLastCourtCaseStatus();
  },
  methods: {
    formatAmount(value) {
      if (value == null) return "-";
      let parts = Number(value).toFixed(2).split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return parts.join(",");
    },
    formatDate(date) {
      return date ? DateTimeToString(date) : "-";
    },
    async getLastCourtCaseStatus() {
      try {
        const response = await LastCourtCaseStatus(this.caseItem.id);
        this.lastCaseStatus = response.data.data[0].status;
        this.lastCaseStatusDate = response.data.data[0].statusDate;
      } catch (error) {
        console.error("Error fetching last court case status:", error);
      }
    },
    async sendToExecution() {
      if (!this.selectedUserId) {
        this.$message.warning("Məsul şəxs seçin");
        return;
      }
      this.respDialogVisible = false;
      const result = await this.$swal({
        title: "Təsdiq edin",
        text: "İşi icraya göndərmək istəyirsiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "İmtina",
        confirmButtonText: "Təsdiq et",
        customClass: {
          confirmButton: "btn bg-gradient-info",
          cancelButton: "btn bg-gradient-secondary",
        },
        buttonsStyling: false,
      });

      if (!result.isConfirmed) return;

      const payload = {
        enforcementOfficer: null,
        courtCaseId: this.caseItem.decision[0].courtCaseId,
        decisionId: this.caseItem.decision[0].id,
        decisionAmount: this.caseItem.decision[0].decisionAmount,
        respUserId: this.selectedUserId,
      };

      try {
        await CreateCourtEnforcement(payload);
        this.$message.success("İş icraya göndərildi");
        this.selectedUserId = null;
        this.$emit("refresh-enforcements");
        this.$emit("refresh-enforcement-tab");
      } catch (e) {
        console.error(e);
        this.$message.error("Xəta baş verdi");
      }
    },
  },
};
</script>

<style scoped>
.record-label-wrapper {
  position: relative;
}

.record-label-tooltip {
  display: block;
  position: absolute;
  top: 100%;
  right: 0;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px;
  z-index: 1000;
  min-width: 180px;
  opacity: 0;
  transform: translateY(5px);
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.record-label-wrapper:hover .record-label-tooltip {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.col-8 {
  color: #222222;
}
</style>
